import { render, staticRenderFns } from "./ConvocationApp.vue?vue&type=template&id=4a61b0d0"
import script from "./ConvocationApp.vue?vue&type=script&lang=js"
export * from "./ConvocationApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports